<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import type { PropType } from 'vue'

interface CInputProps {
  rounded?: string | number | boolean
  variant?:
    | 'filled'
    | 'outlined'
    | 'plain'
    | 'underlined'
    | 'solo'
    | 'solo-inverted'
    | 'solo-filled'
}

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  rounded: {
    type: String as PropType<CInputProps['rounded']>,
    default: 'xl',
  },
  variant: {
    type: String as PropType<CInputProps['variant']>,
    default: 'outlined',
    validator: (value: string): boolean =>
      [
        'filled',
        'outlined',
        'plain',
        'underlined',
        'solo',
        'solo-inverted',
        'solo-filled',
      ].includes(value),
  },
  label: {
    type: String,
    default: 'title',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  hiddenDetail: {
    type: Boolean,
    default: true,
  },
  singleLine: {
    type: Boolean,
    default: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  iconLeft: {
    type: String,
    default: '',
  },
  iconRight: {
    type: String,
    default: '',
  },
  flat: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
})
const emits = defineEmits({
  changed: (event: string) => true,
  clear: (event: MouseEvent) => true,
})

const model = defineModel()
</script>

<template>
  <v-text-field
    :label="props.label"
    :variant="props.variant"
    :hide-details="props.hiddenDetail"
    :single-line="props.singleLine"
    :rounded="props.rounded"
    :loading="props.loading"
    :disabled="props.disabled"
    :append-inner-icon="props.iconRight"
    :prepend-inner-icon="props.iconLeft"
    :readonly="props.readonly"
    :type="props.type"
    :flat="props.flat"
    :clearable="props.clearable"
    density="comfortable"
    v-model="model"
    @click:clear="emits('clear', $event)"
    @update:model-value="emits('changed', $event)"
  ></v-text-field>
</template>
